module.exports = __webpack_public_path__ + "img/map.e8e44c4b.png";